import request from "./API";

const proxyN8n = async (endpoint, payload) => {
 const json = {Folio:payload.Folio,
  ImagenGeneradaBase64: payload.ImagenGeneradaBase64 === undefined || payload.ImagenGeneradaBase64 === null? "": payload.ImagenGeneradaBase64,
  CopyGenerado: payload.CopyGenerado === undefined || payload.CopyGenerado === null? "": payload.CopyGenerado
 }
 const body = await request.post(endpoint, json);

  if (body.ok === false) {
    throw new Error(body.mensaje || "No se pudo procesar la solicitud en n8n");
  }
  return body;
};

// Genera (o regenera) la imagen con firma + copy. Responde con la imagen lista, sin guardar en BD.
export const generarImagenRedes = (payload) => proxyN8n("RedesWebhook/GenerarImagen", payload);

// Confirma que la imagen generada gustó: guarda en BD y envía el correo de evidencia.
export const confirmarImagenRedes = (payload) => proxyN8n("RedesWebhook/ConfirmarImagen", payload);
